// extracted by mini-css-extract-plugin
export var legendIndicator = "_ha-1";
export var legendRight = "_ha-0";